import { InviteeStatusEnum } from '../models/jobInviteeStatusEnum';
import { trimPhone } from './trimPhoneHelper';

type CaseType = 'lower' | 'title' | 'none';

function getPrefixRegexSearchCondition(searchText: string, caseType: CaseType) {
  switch (caseType) {
    case 'lower':
      searchText = searchText.toLowerCase();
      break;
    case 'title':
      searchText =
        searchText.charAt(0).toUpperCase() + searchText.slice(1).toLowerCase();
      break;
    case 'none':
      break;
  }
  return {
    $regex: `^${searchText}`,
  };
}

function getInviteePersonalDataOrConditions(searchText: string) {
  let trimmedPhone = trimPhone(searchText).replace('+', '\\+');

  let inviteeQuery: { [key: string]: { $regex: string } }[] = [
    {
      'personalData.firstName': getPrefixRegexSearchCondition(
        searchText,
        'title',
      ),
    },
    {
      'personalData.lastName': getPrefixRegexSearchCondition(
        searchText,
        'title',
      ),
    },
    {
      'personalData.email': getPrefixRegexSearchCondition(searchText, 'lower'),
    },
  ];

  if (trimmedPhone && trimmedPhone.length > 3) {
    inviteeQuery.push({
      'personalData.phone': getPrefixRegexSearchCondition(trimmedPhone, 'none'),
    });
  }

  return inviteeQuery;
}

export function getUsersMongoSearchQuery(
  searchText: string,
  customerId?: string,
): any[] {
  let filters: any[] = [];
  let searchTexts = searchText.replace('+', '\\+').split(' ');
  let trimmedPhone = trimPhone(searchText).replace('+', '\\+');

  searchTexts.forEach((searchText) => {
    filters.push({
      $or: [
        {
          firstName: {
            $regex: searchText,
            $options: 'i',
          },
        },
        {
          lastName: {
            $regex: searchText,
            $options: 'i',
          },
        },
        {
          email: {
            $regex: searchText,
            $options: 'i',
          },
        },
        {
          phone: {
            $regex: searchText,
            $options: 'i',
          },
        },
        {
          [`customerInformation.${customerId}.tags.displayName`]: {
            $regex: searchText,
            $options: 'i',
          },
        },
        {
          [`customerInformation.${customerId}.poolerType.displayName`]: {
            $regex: searchText,
            $options: 'i',
          },
        },
      ],
    });
    if (trimmedPhone && trimmedPhone.length > 3) {
      filters[filters.length - 1]['$or'].push({
        phone: {
          $regex: trimmedPhone,
        },
      });
    }
  });
  return filters;
}

export function getInviteesMongoSearchQuery(
  searchText: string,
  customerId: string,
  inviteeStatus?: InviteeStatusEnum,
): any[] {
  let filters: any[] = [];
  let searchTexts = searchText.replace('+', '\\+').split(' ');
  let trimmedPhone = trimPhone(searchText).replace('+', '\\+');

  searchTexts.forEach((searchText) => {
    const orConditions: object[] = [
      {
        invitees: {
          $elemMatch: {
            'customer.id': customerId,
            ...(inviteeStatus ? { status: inviteeStatus } : {}),
            $or: getInviteePersonalDataOrConditions(searchText),
          },
        },
      },
      {
        'customer.id': customerId,
        invitees: {
          $elemMatch: {
            status: InviteeStatusEnum.BOOKED,
            $or: getInviteePersonalDataOrConditions(searchText),
          },
        },
      },
      {
        ownerCustomerIds: customerId,
        invitees: {
          $elemMatch: {
            status: InviteeStatusEnum.BOOKED,
            $or: getInviteePersonalDataOrConditions(searchText),
          },
        },
      },
    ];

    if (trimmedPhone && trimmedPhone.length > 3) {
      orConditions.push(
        {
          invitees: {
            $elemMatch: {
              'customer.id': customerId,
              'personalData.phone': getPrefixRegexSearchCondition(
                trimmedPhone,
                'none',
              ),
              ...(inviteeStatus ? { status: inviteeStatus } : {}),
            },
          },
        },
        {
          'customer.id': customerId,
          invitees: {
            $elemMatch: {
              'personalData.phone': getPrefixRegexSearchCondition(
                trimmedPhone,
                'none',
              ),
              status: InviteeStatusEnum.BOOKED,
            },
          },
        },
      );
    }

    filters.push({ $or: orConditions });
  });
  return filters;
}
